module.exports = __webpack_public_path__ + "img/DE00671.648e08ac.png";